import { clsx } from 'clsx'
import { NavLink } from 'react-router'

type NavigationCardProps = {
  to: string
  className: string
  text: string
  title: string
}

export default function NavigationCard({ to, className, title, text }: NavigationCardProps) {
  return (
    <NavLink to={to} className="card-shadow-hover nav-card hover-3d cursor-pointer transition-all">
      <NavigationCardInner className={className} title={title} text={text} />
      {/* 8 empty divs needed for the 3D effect */}
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </NavLink>
  )
}

type NavigationCardInnerProps = {
  className: string
  text: string
  title: string
}

function NavigationCardInner({ className, title, text }: NavigationCardInnerProps) {
  return (
    <div className={clsx('card nav-card-inner flex', className)}>
      <div className="card-face-font flex grow flex-col gap-1 bg-white/20 py-4 pr-[20%] pl-4 sm:gap-1.5 sm:py-6 sm:pr-[45%] sm:pl-6">
        <h3 className="text-xl font-bold md:text-2xl">{title}</h3>
        <p className="invisible font-semibold sm:visible">{text}</p>
      </div>
    </div>
  )
}
